function ResponsePin(props) {
    // adjust the size of the arrow based on the length of the character input
    const len = props.max_length_pinname;

    // let width_outer = (len+10) + 20 + 8;
    // let width_input = (len+10);
    // let arr_endpoint = width_outer-8;
    // width_outer = width_outer.toString()+'px';
    // width_input = width_input.toString()+'px';
    // arr_endpoint = arr_endpoint.toString();
    // let arr_coord="M 16 10 " + arr_endpoint + " 10";


    let width_outer = (len+10) + 20 + 8;
    let width_input = (len+10) + 20 + 8;
    let arr_endpoint = width_outer-8-18;
    let circ_x = arr_endpoint + 11;
    width_outer = width_outer.toString()+'px';
    width_input = width_input.toString()+'px';
    arr_endpoint = arr_endpoint.toString();
    //let arr_coord="M 16 10 " + arr_endpoint + " 10";
    let arr_coord="M 0 10 " + arr_endpoint + " 10";
    circ_x = circ_x.toString();



    return(
        <>
            <div style={{position:'relative', left:'0px', top:'0px', width:width_outer, height:'35px'}}>
                  <input id={'response_pin_'+props.id} placeholder='Response' value={props.name} autoComplete='off' onChange={props.handleEnter} style={{position:'relative', fontSize:'14px', width: width_input, left:'8px', top: "0px", marginLeft: "0px", borderLeft: "2px solid var(--aixelo-red)" , marginTop:"0px", marginBottom:"0px", paddingLeft: "3px"}}/>
                  <div style={{position:'relative', display: 'flex', left:'0px', top:'0px', width:width_outer, height:'20px'}}>
                     <svg style={{position:'relative', left:'0px', top:'-6px', width: '100%', height:'20px'}}>
                         <defs>
                         <marker
                           id="triangleResponse"
                           viewBox="0 0 10 10"
                           refX="1"
                           refY="5"
                           markerUnits="strokeWidth"
                           markerWidth="4"
                           markerHeight="4"
                           orient="auto">
                           <path d="M 0 0 L 10 5 L 0 10 z" fill="var(--aixelo-red)" />
                         </marker>
                       </defs>
                       <circle cx={circ_x} cy="10px" r="5px"            fill="var(--aixelo-red-light)" stroke="var(--aixelo-red)" />
                       <path   d={arr_coord} fill="var(--aixelo-red)" stroke="var(--aixelo-red)" strokeWidth="1.5" markerEnd="url(#triangleResponse)"/>
                     </svg>
                  </div>
            </div>
        </>);

}
export default ResponsePin;